import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
export default {
  props: {
    level: {
      type: String,
      required: true,
      validator: function validator(value) {
        return ['heading1', 'heading2', 'heading3'].includes(value);
      }
    },
    text: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      resolver: {
        heading1: 'h1',
        heading2: 'h2',
        heading3: 'h3'
      }
    };
  },
  computed: {
    textContent: function textContent() {
      return this.text ? this.text.replace(/\n/g, '<br />') : '';
    }
  }
};